import React from 'react';
import NumericInput from 'react-numeric-input';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { currencies } from 'country-data';

const CurrencyInputInline = props => {
  const currency = _.find(currencies.all, ['code', props.currency]);
  let icon = null;
  switch (props.status) {
  case 'PROPOSED':
    icon = 'pending.svg';
    break;
  case 'APPROVED':
    icon = 'complete.svg';
    break;
  case 'REJECTED':
    icon = 'error-small.svg';
    break;
  default:
    icon = null;
    break;
  }
  return (
    <div className={`form-field number status ${props.disabled && 'disabled'} ${props.editable && 'editable'}`} >
      <NumericInput
        value={props.value}
        min={0}
        style={false}
        max={100000000}
        id={props.id}
        name={props.name}
        disabled={!!props.disabled}
        placeholder={props.placeholder}
        onChange={props.onChange}
        onFocus={props.onFocus}
      />
      <p className="field-symbol">{ currency.symbol }</p>
      { props.status &&
        props.status !== 'NONE' &&
        <img className="status-indicator" src={`/icons/${icon}`} alt="budget indicator" />}
    </div>
  );
};

CurrencyInputInline.propTypes = {
  status: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  currency: PropTypes.string,
};

CurrencyInputInline.defaultProps = {
  currency: 'GBP',
};

export default CurrencyInputInline;



/** WEBPACK FOOTER **
 ** ./src/components/currency-input-inline/index.js
 **/